var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FBBF24"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.969,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96031 5.14701C12.2157 5.75134 14.471 6.35565 16.7264 6.95998C17.1047 7.30391 17.1122 7.65707 16.7487 8.01944C16.5374 8.13946 16.3171 8.15393 16.0879 8.06286C15.8085 9.67491 14.9514 10.8621 13.5166 11.6245C12.6605 11.8933 12.536 12.3581 13.1429 13.0189C14.0043 14.3966 14.153 15.8533 13.5889 17.3891C14.0257 17.479 14.2241 17.7444 14.184 18.1855C14.0835 18.4687 13.8857 18.628 13.5904 18.6634C11.3351 18.0591 9.07974 17.4548 6.82437 16.8505C6.446 16.5066 6.43856 16.1534 6.80201 15.791C7.01336 15.671 7.23364 15.6565 7.46288 15.7476C7.7423 14.1356 8.5994 12.9483 10.0342 12.1859C10.8902 11.9171 11.0147 11.4523 10.4078 10.7916C9.54645 9.41389 9.39779 7.95717 9.96183 6.42139C9.52503 6.3315 9.32668 6.06602 9.36675 5.62496C9.46722 5.3418 9.66507 5.18248 9.96031 5.14701ZM10.3276 6.51939C12.1258 7.00122 13.9239 7.48304 15.7221 7.96486C15.456 9.43641 14.6732 10.5292 13.3737 11.2433C13.1534 11.3295 12.9422 11.4322 12.74 11.5512C12.4216 11.8603 12.3139 12.2316 12.417 12.6651C12.5263 12.8878 12.6634 13.092 12.8286 13.2777C13.597 14.5458 13.7285 15.8836 13.2232 17.2911C11.425 16.8092 9.62681 16.3274 7.82862 15.8456C8.09473 14.3741 8.87754 13.2813 10.177 12.5672C10.403 12.494 10.6142 12.3914 10.8108 12.2593C11.0543 12.0372 11.1776 11.7599 11.1807 11.4274C11.1635 11.2527 11.1136 11.0882 11.0311 10.9341C10.1612 9.85978 9.86309 8.64068 10.1369 7.27678C10.1928 7.02239 10.2563 6.76993 10.3276 6.51939Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.982,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.842 9.71965C11.789 9.96523 12.7318 10.226 13.6703 10.502C13.327 10.7676 12.9371 10.9122 12.5006 10.9358C12.3303 10.9894 12.2146 11.1013 12.1534 11.2715C11.9862 11.8153 11.8468 12.3659 11.7353 12.9234C11.6958 13.4607 11.8301 13.9499 12.1383 14.3911C12.5666 14.7984 12.8387 15.2919 12.9543 15.8715C12.9899 16.1483 12.9624 16.4185 12.8718 16.6824C11.3936 16.2863 9.91545 15.8902 8.43727 15.4942C8.59254 14.8698 8.95893 14.4167 9.53645 14.135C9.75967 14.0383 9.98692 13.9522 10.2182 13.8766C10.7056 13.6486 11.0666 13.2921 11.301 12.8071C11.4811 12.2761 11.6337 11.7371 11.7587 11.1902C11.8017 11.0041 11.7595 10.8417 11.632 10.7031C11.2537 10.4627 10.9904 10.1349 10.842 9.71965Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.1163,
    height: 12.1163,
    fill: "white",
    transform: "translate(7.5 4.5) rotate(15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pending-icon.9d60f42605c2648f05f71c38cd7ddb3f.svg";
export { ForwardRef as ReactComponent };